var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { ItemFooter } from "../../Layout/Lists";
import { connect } from 'react-redux';
import docState from "../docState";

export class UploadEntityStatus extends Component {
  renderProgressBar() {
    const isInProgress = this.props.progress || this.props.progress === 0;

    if (isInProgress) {
      return /*#__PURE__*/_jsx(ItemFooter.ProgressBar, { progress: this.props.progress });
    }
  }

  render() {
    if (!this.props.status) {
      return null;
    }

    const ProgressBar = this.renderProgressBar();

    return /*#__PURE__*/(
      _jsx("div", {}, void 0,
      ProgressBar, /*#__PURE__*/
      _jsx(ItemFooter.Label, { status: this.props.status }, void 0, this.props.message)
      ));

  }
}







export function mapStateToProps(state, props) {
  return docState(state, props);
}

export default connect(mapStateToProps)(UploadEntityStatus);